import React from 'react';
import unfollowersDetail from '../img/Detail/Unfollowers-Detail.jpg';
import './Detail.css';
const UnfollowersDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={unfollowersDetail} alt="Mobile App Brand Identity & UI/UX" />
    </div>
  );
};

export default UnfollowersDetail;
